<template>
	<div>
		<b-modal id="modalRegisterPayment" hide-footer :title="title" no-close-on-backdrop no-close-on-esc @close="close" size="md">
			<FormulateForm name="form" class="mt-3" v-model="form" @submit="save">
				<FormulateInput class="mb-3" label="Forma de pago" name="acquirerName" :options="paymentMethods" type="select" validation-name="Forma de pago" validation="required" />

				<FormulateInput label="Referencia" name="externalPaymentId" validation-name="Referencia" validation="required" />

				<FormulateInput
					label="Estado"
					name="status"
					type="select"
					:options="{
						PENDING: 'Pendiente',
						PAID: 'Pago cobrado',
						REJECTED: 'Rechazado',
					}"
				/>

				<div class="d-flex justify-content-end">
					<FormulateInput type="submit" label="Guardar" />
				</div>
			</FormulateForm>
		</b-modal>
	</div>
</template>

<script>
import gql from 'graphql-tag'

export default {
	name: 'OrderRegisterPayment',
	props: ['order'],
	data() {
		return {
			title: 'Crear pago',
			action: 'create',
			id: null,
			loading: false,
			saving: false,
			paymentMethods: [
				{ value: 'RedPagos', label: 'RedPagos' },
				{ value: 'Abitab', label: 'Abitab' },
				{ value: 'Visa', label: 'Visa' },
				{ value: 'Master', label: 'Master' },
			],
			form: {
				externalPaymentId: null,
				acquirerName: null,
				status: null,
			},
		}
	},
	async beforeMount() {},
	methods: {
		open(payment) {
			if (payment) {
				this.title = 'Editar pago'
				this.action = 'update'
				this.id = payment.id
				this.form.acquirerName = payment.acquirerName
				this.form.externalPaymentId = payment.externalPaymentId
				this.form.status = payment.status
			}
			console.log('modalRegisterPayment')
			this.$bvModal.show('modalRegisterPayment')
		},
		close() {
			this.id = null
			this.form = {
				externalPaymentId: null,
				acquirerName: null,
				status: null,
			}
			this.$bvModal.hide('modalRegisterPayment')
			this.$emit('update')
		},

		save() {
			let data = {
				order: this.order.id,
				externalPaymentId: this.form.externalPaymentId,
				acquirerName: this.form.acquirerName,
				status: this.form.status,
			}
			if (this.action == 'create') {
				this.create(data)
			}
			if (this.action == 'update') {
				this.update(data)
			}
		},

		create(data) {
			this.saving = true
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: OrderPaymentInput!) {
							orderPaymentTransactionCreate(data: $data) {
								id
							}
						}
					`,
					variables: {
						data,
					},
				})
				.then(() => {
					this.$toast.success('Pago registrado correctamente')
					this.close()
					this.saving = false
				})
				.catch((error) => {
					this.parseGQLErrors(error)
					this.saving = false
				})
		},

		update(dataInput) {
			this.saving = true
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!, $data: OrderPaymentInput!) {
							orderPaymentTransactionUpdate(id: $id, data: $data) {
								id
							}
						}
					`,
					variables: {
						id: this.id,
						data: dataInput,
					},
				})
				.then(() => {
					this.$toast.success('Pago editado correctamente')
					this.close()
					this.saving = false
				})
				.catch((error) => {
					this.errors = this.parseGQLErrors(error)
					this.saving = false
				})
		},
	},
}
</script>
